module.exports = __webpack_public_path__ + "static/media/bg51.e392d182.jpg";